import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setLogoutHandler, tokenStore } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(async () => {
    const t = tokenStore.get();
    tokenStore.clear();
    setUser(null);
    if (t?.refresh_token) api.post("/auth/logout", { refresh_token: t.refresh_token }).catch(() => {});
  }, []);

  useEffect(() => {
    setLogoutHandler(() => setUser(null));
    if (!tokenStore.get()) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => tokenStore.clear())
      .finally(() => setLoading(false));
  }, []);

  const authenticate = async (path, body) => {
    const { data } = await api.post(path, body);
    tokenStore.set(data);
    setUser(data.user);
    return data.user;
  };

  const value = {
    user,
    loading,
    setUser,
    logout,
    login: (body) => authenticate("/auth/login", body),
    register: (body) => authenticate("/auth/register", body),
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
